'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import WhiteLogo from '../Icons/white-logo';

const footerData = {
  companyInfo: {
    logo: '/images/logo/Wonder-Valves-Light-Logo.svg',
    description:
      'Premium stainless steel ball valve solutions engineered for the most demanding industrial applications. Excellence in design, materials, and performance.',
    socials: [
      { icon: <FaFacebookF data-component-id="src/components/common/Footer.tsx:15:14" data-component-path="src/components/common/Footer.tsx" data-component-line="15" data-component-file="Footer.tsx" data-component-name="FaFacebookF" data-component-content="%7B%22elementName%22%3A%22FaFacebookF%22%7D" />, url: '#' },
      { icon: <FaYoutube data-component-id="src/components/common/Footer.tsx:16:14" data-component-path="src/components/common/Footer.tsx" data-component-line="16" data-component-file="Footer.tsx" data-component-name="FaYoutube" data-component-content="%7B%22elementName%22%3A%22FaYoutube%22%7D" />, url: '#' },
      { icon: <FaInstagram data-component-id="src/components/common/Footer.tsx:17:14" data-component-path="src/components/common/Footer.tsx" data-component-line="17" data-component-file="Footer.tsx" data-component-name="FaInstagram" data-component-content="%7B%22elementName%22%3A%22FaInstagram%22%7D" />, url: '#' },
    ],
  },
  sections: [
    {
      title: 'Ball Valve Products',
      links: [
        { label: 'Flanged 2 Pcs Design', slug: 'flanged-2-pcs-design' },
        { label: 'Flanged 3 Pcs Design', slug: 'flanged-3-pcs-design' },
        { label: 'Butt Weld 2 Pcs Design', slug: 'butt-weld-end-design-2-to-8' },
        { label: 'Butt Weld 3 Pcs Design', slug: 'butt-weld-2-pcs-design' },
        { label: 'Screw/Socket 2 Pcs Design', slug: 'butt-weld-3-pcs-design' },
        { label: 'Screw/Socket 1 Pcs Design', slug: 'screw-socket-2-pcs-design' },
      ],
    },
    {
      title: 'Company',
      links: [
        { label: 'About Us', href: '/about' },
        { label: 'Contact', href: '/contact-us' },
        { label: 'Privacy Policy', href: '/privacy-policy' },
      ],
    },
    {
      title: 'We Support',
      images: [
        { src: '/images/logo/clien-india.svg', alt: 'Swachh Bharat' },
        { src: '/images/logo/Make-in-india.svg', alt: 'Make in India' },
      ],
    },
    {
      title: 'Subscribe to Newsletter',
      newsletter: true,
    },
  ],
};

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = () => {
    console.log('Subscribed:', email);
    setEmail('');
  };

  return (
    <footer data-component-id="src/components/common/Footer.tsx:63:4" data-component-path="src/components/common/Footer.tsx" data-component-line="63" data-component-file="Footer.tsx" data-component-name="footer" data-component-content="%7B%22elementName%22%3A%22footer%22%2C%22className%22%3A%22w-full%20bg-gradient-to-br%20from-%5B%2347011F%5D%20to-%5B%23320015%5D%20text-white%22%7D" className="w-full bg-gradient-to-br from-[#47011F] to-[#320015] text-white">
      <div data-component-id="src/components/common/Footer.tsx:64:6" data-component-path="src/components/common/Footer.tsx" data-component-line="64" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-12%20pt-10%20pb-5%20lg%3Apt-12%20pb-6%22%7D" className="container mx-auto px-4 sm:px-6 lg:px-12 pt-10 pb-5 lg:pt-12 pb-6">
        <div data-component-id="src/components/common/Footer.tsx:65:8" data-component-path="src/components/common/Footer.tsx" data-component-line="65" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-between%20gap-y-10%22%7D" className="flex flex-wrap justify-between gap-y-10">
          {/* Company Info */}
          <div data-component-id="src/components/common/Footer.tsx:67:10" data-component-path="src/components/common/Footer.tsx" data-component-line="67" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20sm%3Aw-1%2F2%20lg%3Aw-%5B22%25%5D%20flex%20flex-col%22%7D" className="w-full sm:w-1/2 lg:w-[22%] flex flex-col">
            <WhiteLogo data-component-id="src/components/common/Footer.tsx:68:12" data-component-path="src/components/common/Footer.tsx" data-component-line="68" data-component-file="Footer.tsx" data-component-name="WhiteLogo" data-component-content="%7B%22elementName%22%3A%22WhiteLogo%22%7D"/>
            <p data-component-id="src/components/common/Footer.tsx:69:12" data-component-path="src/components/common/Footer.tsx" data-component-line="69" data-component-file="Footer.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-4%20text-sm%20leading-6%20text-gray-200%22%7D" className="mt-4 text-sm leading-6 text-gray-200">
              {footerData.companyInfo.description}
            </p>
            <div data-component-id="src/components/common/Footer.tsx:72:12" data-component-path="src/components/common/Footer.tsx" data-component-line="72" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20space-x-3%20mt-5%22%7D" className="flex space-x-3 mt-5">
              {footerData.companyInfo.socials.map((social, index) => (
                <div data-component-id="src/components/common/Footer.tsx:74:16" data-component-path="src/components/common/Footer.tsx" data-component-line="74" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-10%20h-10%20bg-white%2F10%20rounded-full%20flex%20items-center%20justify-center%20hover%3Abg-white%2F20%20transition%22%7D"
                  key={index}
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center hover:bg-white/20 transition"
                >
                  <a data-component-id="src/components/common/Footer.tsx:78:18" data-component-path="src/components/common/Footer.tsx" data-component-line="78" data-component-file="Footer.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22className%22%3A%22text-white%20text-base%22%7D" href={social.url} className="text-white text-base">
                    {social.icon}
                  </a>
                </div>
              ))}
            </div>
          </div>

          {/* Dynamic Sections */}
          {footerData.sections.map((section, idx) => (
            <div data-component-id="src/components/common/Footer.tsx:88:12" data-component-path="src/components/common/Footer.tsx" data-component-line="88" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%7D"
              key={idx}
              className={`w-full sm:w-1/2 ${
                section.newsletter ? 'lg:w-[22%]' : 'lg:w-[16%]'
              } flex flex-col`}
            >
              <h3 data-component-id="src/components/common/Footer.tsx:94:14" data-component-path="src/components/common/Footer.tsx" data-component-line="94" data-component-file="Footer.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%7D"
                className={`${
                  section.newsletter
                    ? 'text-xs font-semibold tracking-[2px] uppercase text-white/70 mb-3'
                    : 'text-base font-bold mb-3'
                }`}
              >
                {section.title}
              </h3>

              {/* Links */}
              {section.links && (
                <ul data-component-id="src/components/common/Footer.tsx:106:16" data-component-path="src/components/common/Footer.tsx" data-component-line="106" data-component-file="Footer.tsx" data-component-name="ul" data-component-content="%7B%22elementName%22%3A%22ul%22%2C%22className%22%3A%22space-y-2%20text-sm%20text-gray-300%22%7D" className="space-y-2 text-sm text-gray-300">
                  {section.links.map((link, i) => (
                    <li data-component-id="src/components/common/Footer.tsx:108:20" data-component-path="src/components/common/Footer.tsx" data-component-line="108" data-component-file="Footer.tsx" data-component-name="li" data-component-content="%7B%22elementName%22%3A%22li%22%7D" key={i}>
                      {'slug' in link ? (
                        <Link data-component-id="src/components/common/Footer.tsx:110:24" data-component-path="src/components/common/Footer.tsx" data-component-line="110" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22hover%3Atext-white%20transition%22%7D"
                          href={`/products/${link.slug}`}
                          className="hover:text-white transition"
                        >
                          {link.label}
                        </Link>
                      ) : (
                        <Link data-component-id="src/components/common/Footer.tsx:117:24" data-component-path="src/components/common/Footer.tsx" data-component-line="117" data-component-file="Footer.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22hover%3Atext-white%20transition%22%7D" href={link.href} className="hover:text-white transition">
                          {link.label}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              )}

              {/* Images */}
              {section.images && (
                <div data-component-id="src/components/common/Footer.tsx:128:16" data-component-path="src/components/common/Footer.tsx" data-component-line="128" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22space-y-3%22%7D" className="space-y-3">
                  {section.images.map((img, i) => (
                    <Image data-component-id="src/components/common/Footer.tsx:130:20" data-component-path="src/components/common/Footer.tsx" data-component-line="130" data-component-file="Footer.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22object-contain%20w-full%20max-w-%5B156px%5D%22%7D"
                      key={i}
                      src={img.src}
                      alt={img.alt}
                      width={156}
                      height={68}
                      className="object-contain w-full max-w-[156px]"
                    />
                  ))}
                </div>
              )}

              {/* Newsletter */}
              {section.newsletter && (
                <>
                  <input data-component-id="src/components/common/Footer.tsx:145:18" data-component-path="src/components/common/Footer.tsx" data-component-line="145" data-component-file="Footer.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22type%22%3A%22email%22%2C%22value%22%3A%22%5Bvar%3Aemail%5D%22%2C%22className%22%3A%22rounded%20px-4%20py-2.5%20text-sm%20bg-white%20text-black%20placeholder-gray-600%20focus%3Aoutline-none%22%7D"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter your email"
                    className="rounded px-4 py-2.5 text-sm bg-white text-black placeholder-gray-600 focus:outline-none"
                  />
                  <button data-component-id="src/components/common/Footer.tsx:152:18" data-component-path="src/components/common/Footer.tsx" data-component-line="152" data-component-file="Footer.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22mt-3%20px-5%20py-2%20rounded%20bg-white%20text-%5B%239C0036%5D%20font-semibold%20text-sm%20hover%3Abg-gray-100%20transition%20w-fit%22%2C%22textContent%22%3A%22Subscribe%22%7D"
                    onClick={handleSubscribe}
                    className="mt-3 px-5 py-2 rounded bg-white text-[#9C0036] font-semibold text-sm hover:bg-gray-100 transition w-fit"
                  >
                    Subscribe
                  </button>
                </>
              )}
            </div>
          ))}
        </div>

        {/* Divider */}
        <div data-component-id="src/components/common/Footer.tsx:165:8" data-component-path="src/components/common/Footer.tsx" data-component-line="165" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mt-10%20border-t%20border-white%2F10%20pt-5%20text-center%22%7D" className="mt-10 border-t border-white/10 pt-5 text-center">
          <div data-component-id="src/components/common/Footer.tsx:166:10" data-component-path="src/components/common/Footer.tsx" data-component-line="166" data-component-file="Footer.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mb-2%22%2C%22textContent%22%3A%22Copyright%20%C2%A9%202025%20%20%20All%20rights%5Cn%20%20%20%20%20%20%20%20%20%20%20%20reserved.%22%7D" className="mb-2">
            Copyright © 2025{' '}
            <span data-component-id="src/components/common/Footer.tsx:168:12" data-component-path="src/components/common/Footer.tsx" data-component-line="168" data-component-file="Footer.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-white%20underline%20font-semibold%22%2C%22textContent%22%3A%22Wonder%20Valves%22%7D" className="text-white underline font-semibold">Wonder Valves</span> All rights
            reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
